import React from "react";
import './Example.scss';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Legend } from 'recharts';

const Example = () => {
  const data = [
    { subject: 'A', student: 3, parent: 10 },
    { subject: 'F', student: 2, parent: 2 },
    { subject: 'B', student: 9, parent: 1 },
    { subject: 'E', student: 5, parent: 5 },
  ];

  return (
    <div className="custom-radar-chart">
      <RadarChart cx="50%" cy="50%" outerRadius="80%" width={600} height={600} data={data}>
        <PolarGrid />
        <PolarRadiusAxis />
        <Radar name="학생 검사 결과" dataKey="student" stroke="#00BFFF" fill="#00BFFF" fillOpacity={0.5} />
        <Radar name="부모 검사 결과" dataKey="parent" stroke="#FF69B4" fill="#FF69B4" fillOpacity={0.3} />
        <Legend />

         {/* ✅ 좌표 최대값을 11로 고정 */}
        <PolarRadiusAxis domain={[0, 11]} />
        
        {/* 🎯 맨 앞으로 오게 마지막에 위치시킴 */}
        <PolarAngleAxis
          dataKey="subject"
          tick={({ payload, x, y, textAnchor }) => {
            const isB = payload.value === 'B';
            return (
              <text
                x={x}
                y={y + (isB ? 10 : 0)}
                textAnchor={textAnchor}
                className={isB ? "label-b" : "label-default"}
              >
                {payload.value}
              </text>
            );
          }}
        />
      </RadarChart>
    </div>
  );
};

export default Example;
